import cliBoxes from './boxes.json' with {type: 'json'};

export default cliBoxes;
